import React, { useEffect, useState } from "react";
import useAxios from "../../hooks/useAxios";
import { Button, Card } from "react-bootstrap";
import { Loading } from "../../Components/Loading";
import { useNavigate, useParams } from "react-router-dom";
import { GuardKitItemForm } from "../../Components/GuardKitItems/GuardKitItemForm";

const EditGuardKitItem = () => {
  const { get } = useAxios();
  const navigate = useNavigate();
  let { guardKitItemId } = useParams();
  const [fetching, setFetching] = useState(true);
  const [guardKitItem, setGuardKitItem] = useState({});

  useEffect(() => {
    setFetching(true);
    const getDetailedGuardKitItem = async () => {
      try {
        const response = await get(`guardkit/${guardKitItemId}`);
        setGuardKitItem(response.data.guard_kit);
      } catch (error) {
        if (error.response.status === 500) {
        }
      } finally {
        setFetching(false);
      }
    };
    getDetailedGuardKitItem();
  }, []);

  return (
    <>
      {!!fetching && <Loading />}

      {!fetching && !!guardKitItem?.id && (
        <Card className="container">
          <Card.Header className="d-flex justify-content-between mt-0 mb-5">
            <Card.Title>
              <div className="row">
                <div className="col-md-12">
                  <h1 className="page-title">Edit Kit Item</h1>
                </div>
              </div>
            </Card.Title>

            <div className="row">
              <div className="col-md-12">
                <Button onClick={() => navigate(-1)}>Back</Button>
              </div>
            </div>
          </Card.Header>

          <Card.Body>
            <GuardKitItemForm editGuardKitItem={guardKitItem} />
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default EditGuardKitItem;
